/* kischt story, French copy (31 Oct 2026). Same script as assets/kischt-story.js with the French
   lightbox and gallery strings; loaded instead of it for French visitors (language fr) on the fleece
   tights templates. When kischt-story.js changes, rebuild this file with
   /home/claude/fr_work/build/fr_story_js.py (see the README in theme_backup_fr_2026-10-31). */
/* Kischt product story: colour photography, photo viewer and pack buy box integration.
   Uses the buy box colour controls. No product form or cart logic is included. */
(function () {
  'use strict';

  if (window.KischtStory && window.KischtStory.init) {
    window.KischtStory.init(document);
    return;
  }

  var initialized = new WeakSet();
  var selector = '[data-kp-section]';

  function isVisible(element) {
    if (!element || !element.getClientRects().length) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function motionBehavior() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }

  function scrollToTarget(target) {
    if (!target) return;
    target.scrollIntoView({ behavior: motionBehavior(), block: 'start' });
    var focusTarget = target.matches('form')
      ? target.querySelector('select:not([disabled]), input:not([type="hidden"]):not([disabled]), button[type="submit"]:not([disabled])')
      : target;
    if (!focusTarget || !isVisible(focusTarget)) focusTarget = target;
    var temporaryTabindex = !focusTarget.hasAttribute('tabindex') && !focusTarget.matches('a[href],button,input,select,textarea');
    if (temporaryTabindex) focusTarget.setAttribute('tabindex', '-1');
    focusTarget.focus({ preventScroll: true });
    if (temporaryTabindex) {
      focusTarget.addEventListener('blur', function () {
        focusTarget.removeAttribute('tabindex');
      }, { once: true });
    }
  }

  function initSection(section) {
    if (initialized.has(section)) {
      if (section._kpResumeColours) section._kpResumeColours();
      return;
    }
    initialized.add(section);

    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-kp-colour]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-kp-panel]'));
    var status = section.querySelector('[data-kp-gallery-status]');
    var tabList = section.querySelector('[data-kp-tabs]');

    function selectColour(tab, announce, moveFocus) {
      if (!tab) return;
      var colour = tab.getAttribute('data-kp-colour');
      tabs.forEach(function (item) {
        var selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-kp-panel') !== colour;
      });
      if (moveFocus) tab.focus({ preventScroll: true });
      if (tabList && tabList.scrollWidth > tabList.clientWidth && (announce || moveFocus)) {
        var left = tab.offsetLeft - tabList.offsetLeft - (tabList.clientWidth - tab.offsetWidth) / 2;
        tabList.scrollTo({ left: left, behavior: motionBehavior() });
      }
      if (announce && status) status.textContent = 'Teinte ' + tab.textContent.trim() + ' : vues de face, de dos et de détail.';
      updateGalleryLink(tab);
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { selectColour(tab, true, false); });
      tab.addEventListener('keydown', function (event) {
        var nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabs.length - 1;
        else return;
        event.preventDefault();
        selectColour(tabs[nextIndex], true, true);
      });
    });

    if (tabs.length && panels.length) selectColour(tabs[0], false, false);
    section.classList.add('kp-is-ready');

    // Native details stay usable if JavaScript is unavailable.
    var faqItems = Array.prototype.slice.call(section.querySelectorAll('.kp-faq-item'));
    faqItems.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        faqItems.forEach(function (other) { if (other !== item) other.open = false; });
      });
    });

    // The supplied custom buy box owns sizes, stock, prices and cart mutations.
    function updateGalleryLink(tab) {
      if (!tab) return;
      var handle = tab.getAttribute('data-kp-handle');
      section.querySelectorAll('[data-kp-shop-colour]').forEach(function (link) {
        link.setAttribute('data-kp-handle', handle);
        link.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'products/' + encodeURIComponent(handle);
        var label = link.querySelector('[data-kp-shop-label]');
        if (label) label.textContent = 'Choisir ' + tab.getAttribute('data-kp-name');
      });
    }

    function syncFromBuybox() {
      var selected = document.querySelector('#kpuColours [data-kpu-colour][aria-pressed="true"]');
      if (!selected) return;
      var tab = tabs.find(function (item) {
        return item.getAttribute('data-kp-handle') === selected.getAttribute('data-kpu-colour');
      });
      if (tab) selectColour(tab, false, false);
    }
    syncFromBuybox();
    var buyColours = document.getElementById('kpuColours');
    if (buyColours) {
      var colourObserver = new MutationObserver(syncFromBuybox);
      section._kpColourObserver = colourObserver;
      section._kpResumeColours = function () {
        var currentColours = document.getElementById('kpuColours');
        colourObserver.disconnect();
        if (currentColours) colourObserver.observe(currentColours, { childList:true, subtree:true, attributes:true, attributeFilter:['aria-pressed'] });
        syncFromBuybox();
      };
      section._kpResumeColours();
    }

    function findPurchaseTarget() {
      var targetSelector = section.getAttribute('data-kp-buy-target');
      if (targetSelector) {
        try {
          var explicitTarget = document.querySelector(targetSelector);
          if (isVisible(explicitTarget)) return explicitTarget;
        } catch (error) { /* Ignore an invalid custom selector and use native detection. */ }
      }
      var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
      return forms.find(function (form) {
        return !section.contains(form) && !form.closest('dialog,[role="dialog"],cart-drawer') && isVisible(form) && !!form.querySelector('[name="id"]');
      }) || null;
    }

    var dialog = section.querySelector('[data-kp-dialog]');
    var fullImage = section.querySelector('[data-kp-full-image]');
    var caption = section.querySelector('[data-kp-photo-caption]');
    var previous = section.querySelector('[data-kp-previous]');
    var next = section.querySelector('[data-kp-next]');
    var activePhotos = [];
    var photoIndex = 0;
    var openedFrom = null;
    var scrollOverflow = null;
    var currentCaption = '';

    function renderPhoto() {
      var link = activePhotos[photoIndex];
      if (!link || !fullImage || !caption) return;
      var img = link.querySelector('img');
      currentCaption = (photoIndex + 1) + ' / ' + activePhotos.length + ' · ' + (img ? img.alt : 'Photo de produit Kischt');
      fullImage.alt = img ? img.alt : 'Photo de produit Kischt';
      fullImage.src = link.href;
      caption.textContent = currentCaption;
      previous.hidden = next.hidden = activePhotos.length < 2;
    }

    function openPhoto(link) {
      if (!dialog || typeof dialog.showModal !== 'function') return false;
      var group = link.getAttribute('data-kp-group');
      activePhotos = Array.prototype.slice.call(section.querySelectorAll('[data-kp-zoom]')).filter(function (item) {
        return item.getAttribute('data-kp-group') === group && isVisible(item);
      });
      photoIndex = Math.max(activePhotos.indexOf(link), 0);
      openedFrom = link;
      renderPhoto();
      dialog.showModal();
      scrollOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      return true;
    }

    function changePhoto(direction) {
      if (!activePhotos.length) return;
      photoIndex = (photoIndex + direction + activePhotos.length) % activePhotos.length;
      renderPhoto();
    }

    if (dialog && typeof dialog.showModal === 'function') {
      section.querySelector('[data-kp-close]').addEventListener('click', function () { dialog.close(); });
      previous.addEventListener('click', function () { changePhoto(-1); });
      next.addEventListener('click', function () { changePhoto(1); });
      fullImage.addEventListener('error', function () { caption.textContent = 'Cette photo n’a pas pu se charger. Fermez cette vue et réessayez.'; });
      fullImage.addEventListener('load', function () { caption.textContent = currentCaption; });
      dialog.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        changePhoto(event.key === 'ArrowLeft' ? -1 : 1);
      });
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        var rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', function () {
        if (scrollOverflow !== null) document.documentElement.style.overflow = scrollOverflow;
        scrollOverflow = null;
        if (openedFrom && openedFrom.isConnected) openedFrom.focus({ preventScroll: true });
      });
    }

    section.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target.closest('a');
      if (!link || !section.contains(link)) return;
      if (link.hasAttribute('data-kp-zoom')) {
        if (openPhoto(link)) event.preventDefault();
        return;
      }
      if (link.hasAttribute('data-kp-fit')) {
        var fitButton = document.getElementById('kpuFitButton');
        if (fitButton && !fitButton.disabled) {
          event.preventDefault();
          fitButton.click();
        }
        return;
      }
      if (link.hasAttribute('data-kp-shop')) {
        var purchaseTarget = findPurchaseTarget();
        if (purchaseTarget) {
          if (link.hasAttribute('data-kp-shop-colour')) {
            var handle = link.getAttribute('data-kp-handle');
            var buyButton = Array.prototype.slice.call(document.querySelectorAll('#kpuColours [data-kpu-colour]')).find(function (button) {
              return button.getAttribute('data-kpu-colour') === handle;
            });
            // If the buy box has not initialized, use the actual product-page link.
            if (!buyButton || buyButton.disabled) return;
            if (buyButton.getAttribute('aria-pressed') !== 'true') buyButton.click();
          }
          if (link.hasAttribute('data-kp-shop-bundle')) {
            var packButton = document.querySelector('#kpuPacks [data-kpu-pack="' + link.getAttribute('data-kp-shop-pack') + '"]');
            // If the buy box has not initialized, follow the pack's product page link.
            if (!packButton || packButton.disabled) return;
            if (packButton.getAttribute('aria-pressed') !== 'true') packButton.click();
            var bundleHandle = link.getAttribute('data-kp-shop-bundle');
            var bundleButton = Array.prototype.slice.call(document.querySelectorAll('#kpuBundles [data-kpu-bundle]')).find(function (button) {
              return button.getAttribute('data-kpu-bundle') === bundleHandle;
            });
            if (bundleButton && bundleButton.getAttribute('aria-pressed') !== 'true') bundleButton.click();
          }
          event.preventDefault();
          scrollToTarget(purchaseTarget);
        }
        return;
      }
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;
      var target = document.getElementById(href.slice(1));
      if (target && (target === section || section.contains(target))) {
        event.preventDefault();
        scrollToTarget(target);
      }
    });
  }

  function init(root) {
    if (root.matches && root.matches(selector)) initSection(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(initSection);
  }

  window.KischtStory = { init: init };

  function start() {
    init(document);
    // Supports sections injected after page load by Shopify and page builders.
    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) { if (node.nodeType === 1) init(node); });
        record.removedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          var openDialog = node.matches && node.matches('dialog[open]') ? node : node.querySelector && node.querySelector('dialog[open]');
          if (openDialog && openDialog.matches('[data-kp-dialog]') && !openDialog.isConnected) openDialog.close();
          var removedSections = node.matches && node.matches(selector) ? [node] : node.querySelectorAll ? Array.prototype.slice.call(node.querySelectorAll(selector)) : [];
          removedSections.forEach(function (removed) {
            if (!removed.isConnected && removed._kpColourObserver) {
              removed._kpColourObserver.disconnect();
            }
          });
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();